import { I18n } from "@assets/strings";
import React, { useState } from "react";
import styled from "styled-components";
import { allLanguages, CurrentProfile, Language } from "@domain/currentProfile/currentProfile";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useIsMobile, useLanguageFromProfile } from "@utils/hooks";
import { Primary } from "@ui/components/containers/primary";
import { Selecter } from "@ui/components/inputs/selecter";
// import { useModalTools } from "../../modals/modalContext";
// import { ChangeEmailModal } from "./ChangeEmailModal";
// import { useConfirmation } from "../../modals/useConfirmation";
// import { useServices } from "../../../core/servicesContext";
// import { createToast } from "../../toasts/utils";
import { allCurrenciesCode, CurrencyCode } from "@domain/currency/currency";
// import { useHistory } from "react-router";
// import { Path } from "../../../core/routing/path";
interface SystemSettingsProps extends React.HTMLAttributes<HTMLDivElement> {
	onLanguageChange?: (language: Language) => Promise<CurrentProfile>;
	onCurrencyChange?: (currency: CurrencyCode) => Promise<CurrentProfile>;
}

export const SystemSettings: React.FC<SystemSettingsProps> = ({ onLanguageChange, onCurrencyChange, ...htmlProps }) => {
	const currentProfile = useCurrentProfile();
	const [language, setLanguage] = useState<Language | undefined>(currentProfile?.language);
	const [currency, setCurrency] = useState<CurrencyCode | undefined>(currentProfile?.currency);
	useLanguageFromProfile(language);
	//useCurrencyFromProfile(currency);
	// const { currentProfileService } = useServices();
	// const askConfirmation = useConfirmation(I18n.t("settings.delete.account.label"), I18n.t("delete"), "");
	// const { createModal } = useModalTools();
	const isMobile = useIsMobile();
	const styles = {
		customtd: {
			paddingTop: isMobile ? "0" : "35px",
		},

		tdchangemodifyemail: {
			margin: 0,
		},
	};

	// const history = useHistory();

	return (
		<Container {...htmlProps}>
			<tbody>
				<tr>
					<td>
						<Primary>
							<b>{I18n.t(`settings.system.content.language.title`)}</b>
						</Primary>
					</td>
					<td>
						<Selecter
							value={language ? language : I18n.t("onboarding.language.placeholder")}
							onChange={(value) => {
								setLanguage(value as Language);
								onLanguageChange?.(value as Language);
							}}
							placeholder={I18n.t("onboarding.language.placeholder")}
							options={allLanguages.map((lang) => ({
								value: lang,
								label: I18n.t(`onboarding.language.${lang}`),
							}))}
						/>
					</td>
				</tr>
				<tr>
					<td style={styles.customtd}>
						<Primary>
							<b>{I18n.t(`settings.system.content.currency.title`)}</b>
						</Primary>
					</td>
					<td style={styles.customtd}>
						<Selecter
							value={currency ? currency : I18n.t("settings.currency.placeholder")}
							onChange={(value) => {
								setCurrency(value as CurrencyCode);
								onCurrencyChange?.(value as CurrencyCode);
								console.log("Chosen currency:" + value);
							}}
							placeholder={I18n.t("settings.currency.placeholder")}
							options={allCurrenciesCode.map((currency) => ({
								value: currency,
								label: I18n.t(`settings.currency.${currency}`),
							}))}
						/>
					</td>
				</tr>
				{/* <tr>
					<td style={styles.customtd}>
						<Primary>
							<b>{I18n.t("settings.system.content.email.title")}</b>
						</Primary>
					</td>

					<td style={styles.customtd}>
						<Primary>
							<EmailText>
								<MaxWidth>{currentProfile?.email}</MaxWidth>
							</EmailText>
						</Primary>
					</td>
				</tr> */}
				{/* <tr>
					{!isMobile ? <td></td> : null}
					<td style={styles.tdchangemodifyemail}>
						<Primary>
							<ModifyEmailText onClick={() => createModal((close) => <ChangeEmailModal close={close} />)}>
								<b>{I18n.t("settings.change.email.link.title")}</b>
							</ModifyEmailText>
						</Primary>
					</td>
				</tr> */}
				{/* <tr>
					{!isMobile ? <td></td> : null}
					<td style={styles.tdchangemodifyemail}>
						<Primary>
							<LinkDeleteAccount
								onClick={() =>
									askConfirmation(async () => {
										try {
											await currentProfileService.delete();

											createToast(I18n.t("success"), I18n.t("settings.delete.account.success"), "success");
										} catch (e) {
											createToast(I18n.t("error"), I18n.t("auth.error.default"), "error");
										}
									})
								}
							>
								<b>{I18n.t("settings.delete.account.link.title")}</b>
							</LinkDeleteAccount>
						</Primary>
					</td>
				</tr> */}
			</tbody>
		</Container>
	);
};
const Container = styled.table`
	width: 100%;
	@media (max-width: 900px) {
		table-layout: fixed;
		td {
			display: block;
			margin: 10px auto 10px;
			padding-top: 0;
		}
	}
`;

// const EmailText = styled.div`
// 	background-color: #f3f4f6;
// 	padding: 13px 16px;
// 	border-radius: 13px;
// `;
// const MaxWidth = styled.div`
// 	@media (max-width: 900px) {
// 		display: block;
// 		overflow: hidden;
// 		white-space: nowrap;
// 		text-overflow: ellipsis;
// 	}
// `;

// const ModifyEmailText = styled.div`
// 	${({ theme }) => theme.textStyles.light};
// 	color: ${({ theme }) => theme.colors.vividBlue};
// 	cursor: pointer;
// 	margin-top: 10px;
// 	@media (max-width: 900px) {
// 		margin-top: 0;
// 	}
// `;

// const LinkDeleteAccount = styled.div`
// 	${({ theme }) => theme.textStyles.light};
// 	color: ${({ theme }) => theme.colors.red};
// 	cursor: pointer;
// 	margin-top: 10px;
// 	@media (max-width: 900px) {
// 		margin-top: 0;
// 	}
// `;
